import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/shared/components/ui/alert-dialog";
import { useTranslation } from "react-i18next";

interface ScheduleConfirmDialogsProps {
  blockMeetingId: string | null;
  setBlockMeetingId: (id: string | null) => void;
  confirmBlockMeeting: () => void;
  blockSeriesId: string | null;
  setBlockSeriesId: (id: string | null) => void;
  confirmBlockSeries: () => void;
  forceLeaveCallId: string | null;
  setForceLeaveCallId: (id: string | null) => void;
  confirmForceLeaveCall: () => void;
}

export const ScheduleConfirmDialogs = ({
  blockMeetingId,
  setBlockMeetingId,
  confirmBlockMeeting,
  blockSeriesId,
  setBlockSeriesId,
  confirmBlockSeries,
  forceLeaveCallId,
  setForceLeaveCallId,
  confirmForceLeaveCall,
}: ScheduleConfirmDialogsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <AlertDialog open={!!blockMeetingId} onOpenChange={() => setBlockMeetingId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("assistant.schedule.confirmBlockMeetingTitle")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("assistant.schedule.confirmBlockMeetingDescription")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("assistant.schedule.confirmCancelButton")}</AlertDialogCancel>
            <AlertDialogAction onClick={confirmBlockMeeting} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
              {t("assistant.schedule.confirmButton")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={!!blockSeriesId} onOpenChange={() => setBlockSeriesId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("assistant.schedule.confirmBlockSeriesTitle")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("assistant.schedule.confirmBlockSeriesDescription")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("assistant.schedule.confirmCancelButton")}</AlertDialogCancel>
            <AlertDialogAction onClick={confirmBlockSeries} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
              {t("assistant.schedule.confirmButton")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={!!forceLeaveCallId} onOpenChange={() => setForceLeaveCallId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("assistant.schedule.confirmForceLeaveTitle")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("assistant.schedule.confirmForceLeaveDescription")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("assistant.schedule.confirmCancelButton")}</AlertDialogCancel>
            <AlertDialogAction onClick={confirmForceLeaveCall} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
              {t("assistant.schedule.confirmButton")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
